/*
 * @Date: 2020-12-21 09:42:40
 * @Description: request
 */
import axios from 'axios';

import i18n from '@/locales';
import store from '@/store';
import { VueAxios } from './axios';
import notification from '@/components/Notification';

axios.defaults.withCredentials = true;

// 创建 axios 实例
const instance = axios.create({
    // API 请求的默认前缀
    baseURL: '/api'
    // timeout: 10000 // 请求超时时间
});

// 异常拦截处理器
const errorHandler = (error) => {
    debugger
    const { message, response = {} } = error || {};
    const { data = {}, status } = response || {};
    if (Number(status) === 401) {
        // window.location.href =
        //     process.env.VUE_APP_SSO_LOGIN_URL +
        //     `?redirectUrl=${encodeURIComponent(window.location.href)}`;
        // return Promise.reject(error);
    }
    if (
        error.request &&
        error.request.readyState === 4 &&
        error.request.status === 0 &&
        error.request.statusText === ''
    ) {
        if (error.message.includes('timeout')) {
            notification.error({
                message: 'Error',
                description: error.message
            });
            return Promise.reject(error);
        } else {
            window.location.reload();
            return;
        }
    }
    const { message: msg } = data || {};
    // notification.error({
    //     message: `Error [${status}]`,
    //     description: msg || message || i18n.t(`error.internal`)
    // });
    // eslint-disable-next-line compat/compat
    return Promise.reject(error);
};

// request interceptor
instance.interceptors.request.use((config) => {
    config.headers.common['Accept-Language'] = store.getters.lang;
    return config;
}, errorHandler);

// response interceptor
instance.interceptors.response.use((response) => {
    const { data = {}, status, statusText } = response || {};
    if (Number(status) !== 200 ) {
        // notification.error({
        //     message: `Error[${status}]`,
        //     description: i18n.t(`error.request.${status}`) || statusText
        // });
        throw new Error(statusText);
    }
    const { code, message } = data || {};
    if (!code) {
        return data; // 比如下载，不返回resultDTO
    }
    if (Number(code) !== 200 && Number(code) !== 10001 && Number(code) !== 10002 && Number(code) !== 10003 && Number(code) !== 10004 && Number(code) !== 10005 && Number(code) !== 10006 && Number(code) !== 10007 && Number(code) !== 10008 && Number(code) !== 20001) {
        // notification.error({ message: `Error[${code}]`, description: message });
        throw new Error(statusText);
    }
    if(Number(code) === 10001 || Number(code) === 10002 || Number(code) === 10003 || Number(code) === 10004 || Number(code) === 10005 || Number(code) === 10006 || Number(code) === 10007 || Number(code) === 10008 || Number(code) === 20001){
        return data;
    }
    return data.data;
}, errorHandler);

const Installer = {
    vm: {},
    install(Vue) {
        Vue.use(VueAxios, instance);
    }
};

export default instance;

export { Installer };
